<div class="container-fluid pl-0 pr-0">
    <div class="d-none d-sm-block">
        <div class="row " style="padding-top: 2px;">
            <div class="col">
                <h6 class="page-header pt-1" style="margin-left: 15px; margin-top: 6px;">{{ 'customercontrol.title' | trans }}</h6>
                <p class="page-header-sub" style="margin-left: 15px;">{{ 'customercontrol.subtitle' | trans }}</p>
              </div>
            <div *ngIf="canCreateCustomer()"  class="d-inline-flex">
                    <input
                    type="text" class="mt-0 form-control h-40 mb-1 filterbox rounded" placeholder="{{ 'projectlist.filterplace' | trans }}" aria-label="Type to filter" aria-describedby="basic-addon2" name="textFilter" [(ngModel)]="filterTxt" >
                <app-tagfilter [label]="true" [listToFilter]="customerList" (filteredList)="setFilteredList($event)" style="margin-top:26px; margin-right:7px; margin-left:0px;" [tagtype]="'customer'"></app-tagfilter>
                <button data-toggle="modal" data-target="#customercreateModal" matTooltip="{{ 'customercontrol.createnewcustomertip' | trans }}" aria-label="create customer" matTooltipPosition="left" matTooltipShowDelay="500"
                 class="btn-empty border-0" style="margin-top:14px; margin-right:7px; margin-left:0px;" type="button" 
                id="dropdownMenuButton" 
                  aria-haspopup="true" aria-expanded="false">
                  <span class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn portal-icon p-0 mr-2 center cursor-pointer">
                    add
                    </span>
                </button>
              
            </div>
        </div>
    </div>


    <!----MOBILE VERSION-->
    <div class="d-block d-sm-none">
        <div class="d-flex flex-row" style="padding-top: 2px;">
            <div class="">
                <h6 class="page-header pt-1" style="margin-left: 15px; margin-top: 6px;">{{ 'customercontrol.title' | trans }}</h6>
                <p class="page-header-sub" style="margin-left: 15px;">{{ 'customercontrol.subtitle' | trans }}</p>
              </div>
            <div *ngIf="canCreateCustomer()"  class="d-inline-flex">
                <app-tagfilter [label]="true" [listToFilter]="customerList" (filteredList)="setFilteredList($event)" style="margin-top:37px; margin-right:7px; margin-left:0px;" [tagtype]="'customer'"></app-tagfilter>
                <button data-toggle="modal" data-target="#customercreateModal" matTooltip="{{ 'customercontrol.createnewcustomertip' | trans }}" aria-label="create customer" matTooltipPosition="left" matTooltipShowDelay="500"
                 class="btn-empty border-0" style="margin-top:14px; margin-right:7px; margin-left:0px;" type="button" 
                id="dropdownMenuButton" 
                  aria-haspopup="true" aria-expanded="false">
                  <span class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn portal-icon p-0 mr-2 center cursor-pointer">
                    add
                    </span>
                </button>
              
            </div>
        </div>
    </div>
    <div class="row d-block d-sm-none">
        <input type="text" class="mt-0 form-control h-40 mb-3 filterbox-m ml-3 mr-3 rounded" placeholder="{{ 'projectlist.filterplace' | trans }}" aria-label="Type to filter" aria-describedby="basic-addon2" name="textFilter" [(ngModel)]="filterTxt" >
    </div>

<div class="card bg-secondary">
    <div *ngIf="customerList.length == 0" class="row">
        <p class="mb-0 p-3 pl-4 font-weight-bold">{{ 'customercontrol.nocustomers' | trans }}</p>
        <button data-toggle="modal" data-target="#customercreateModal" matTooltip="{{ 'customercontrol.createnewcustomertip' | trans }}" aria-label="create customer" matTooltipPosition="left" matTooltipShowDelay="500"
        class="btn-empty border-0" type="button" 
       id="dropdownMenuButton" 
         aria-haspopup="true" aria-expanded="false">
         <span class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn portal-icon p-0 mr-2 center cursor-pointer">
           add
           </span>
       </button>
</div>
    <app-customer-card
  *ngFor="let customer of filteredCustomerList | appFilter: filterTxt"
  [customer]="customer"
  [filterTxt]="filterTxt"
  [hubspotintegration]="hubspotintegration">
</app-customer-card>
<div class="card bg-secondary p-3" *ngIf="customerList.length > 0 && filteredCustomerList.length == 0">
    <p class="mb-0 font-weight-bold">{{ 'customercontrol.nomatch' | trans }}</p>
</div>
</div>
<!---MODAL CREATE-->
<div class="modal modal-customer" id="customercreateModal" tabindex="-1" role="dialog" >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ 'customercontrol.createcustomer' | trans }}</h5>
            <button type="button" class="close" data-dismiss="modal" #customercreateModal aria-label="Close">
              <span >&times;</span>
            </button>
          </div>
        <div class="modal-body pt-1">
                <div *ngIf="errorMessage!=null" class="alert alert-danger">
                    {{ errorMessage | trans }}
                </div>
                <form #profileForm="ngForm" class="p-1" (ngSubmit)="onRegister()">
                <div class="form-group mb-1">
                    <label class="f-13 font-weight-light mb-0 text-muted" for="signupName">{{ 'customercontrol.name' | trans }}</label>
                    <input id="signupName"  type="text" placeholder="{{ 'customercontrol.nameplace' | trans }}" maxlength="50" class="form-control" name="title" [(ngModel)]="createCustomer.title" required>
                </div>

                <div class="form-group mb-1" >
                    <label class="f-13 font-weight-light mb-0 text-muted" for="signupDescription">{{ 'customercontrol.description' | trans }}</label>
                    <quill-editor [modules]="modules" theme="snow" id="signupDescription" class="w-100 toolontop" name="description" [(ngModel)]="createCustomer.description"><p>{{ 'customercontrol.descriptionplace' | trans }}</p></quill-editor>
                  </div>

                <!-- <div class="form-group mb-1">
                    <label class="f-13 font-weight-light mb-0 text-muted" for="signupDescription">Description</label>
                    <input id="signupDescription"  type="text" placeholder="Customer Description Here..." maxlength="50" class="form-control" name="description" [(ngModel)]="createCustomer.description" >
                </div> -->

                <div class="form-group mb-1">
                    <label class="f-13 font-weight-light mb-0 text-muted" for="signupWww">{{ 'customercontrol.website' | trans }}</label>
                    <input id="signupWww"  type="text" placeholder="{{ 'customercontrol.websitenplace' | trans }}" maxlength="50" class="form-control" name="website" [(ngModel)]="createCustomer.website" required>
                </div>
                <div class="form-group mb-1">
                    <label class="f-13 font-weight-light mb-0 text-muted" for="signupAddress1">{{ 'customercontrol.address' | trans }}</label>
                    <input id="signupAddress1"  type="text" placeholder="{{ 'customercontrol.addressplace' | trans }}." maxlength="50" class="form-control" name="address1" [(ngModel)]="createCustomer.address1" required>
                </div>
                <div class="form-group mb-1">
                    <label class="f-13 font-weight-light mb-0 text-muted" for="signupAddress2">{{ 'customercontrol.address2' | trans }}</label>
                    <input id="signupAddress2"  type="text" placeholder="{{ 'customercontrol.address2place' | trans }}" maxlength="50" class="form-control" name="address2" [(ngModel)]="createCustomer.address2" required>
                </div>
                <div class="form-group mb-1">
                    <label class="f-13 font-weight-light mb-0 text-muted" for="signupCity">{{ 'customercontrol.city' | trans }}</label>
                    <input id="signupCity"  type="text" placeholder="{{ 'customercontrol.cityplace' | trans }}" maxlength="50" class="form-control" name="city" [(ngModel)]="createCustomer.city" required>
                </div>
                <div class="form-group mb-1">
                    <label class="f-13 font-weight-light mb-0 text-muted" for="signupZip">{{ 'customercontrol.zip' | trans }}</label>
                    <input id="signupZip"  type="text" placeholder="{{ 'customercontrol.zipplace' | trans }}" maxlength="50" class="form-control" name="zip" [(ngModel)]="createCustomer.zip" required>
                </div>
                <div class="form-group mb-1">
                    <label class="f-13 font-weight-light mb-0 text-muted" for="signupContact">{{ 'customercontrol.maincontact' | trans }}</label>
                    <input id="signupContact" type="text" placeholder="{{ 'customercontrol.maincontactplace' | trans }}" maxlength="50" class="form-control" name="main_contact" [(ngModel)]="createCustomer.main_contact" required>
                </div>
                <div class="row" style="margin-top:20px;">
                </div>
                <div class="row">
                    <div class="col">
                        <button class="btn-close" data-dismiss="modal"><p class="btn-save-text">{{ 'customercontrol.cancel' | trans }}</p></button>
                    </div>
                        <div class="col">
                            <button id="signupSubmit" type="submit" class="btn-save" >
                                <p class="btn-save-text">{{ 'customercontrol.createyourcustomer' | trans }}</p>
                                </button>
                    </div>
                </div>
            </form>
        </div>
      </div>
    </div>
  </div>
</div>

  